/**
 * @module actions/carrentalalternatives
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Get list of rentalcars alternatives
 * @return {Promise} Axios promise
 */
export function GetCarRentalAlts () {
  let url = API_URL + '/CarRentalAlternatives/Get'
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/carrentalalternatives.js